<template>
  <div>
    <div class="form__field">
                <label>
                    <input @change="save" type="checkbox" v-model="form.marketing_email"/> <strong>Email</strong>
                </label>
            </div>

            <div class="form__field">
                <label>
                    <input @change="save" type="checkbox" v-model="form.marketing_sms"/> <strong>SMS</strong>
                </label>
            </div>
  </div>
</template>

<script>
import {Form} from 'vform'
export default {
    props: {
        user:{
            required: true,
            type: Object
        }
    },
    data(){
        return {
            form: new Form({
                'marketing_email' : false,
                'marketing_sms' : false
            })
        }
    },
    created(){
        this.form.fill(this.user);
    },
    methods: {
        save(){
            this.form.post('/account/marketing').then((response)=>{
                this.$message({
                    message: 'Marketing preferences updated!',
                    type: 'success'
                });
            });
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/js/components/Account/marketing.vue